import React__default, { Component } from 'react';
import { __extends } from '../../_virtual/_tslib.js';
import MessageBubbleFile from '../MessageBubbleFile/index.js';

var MessageFilePart =
/** @class */
function (_super) {
  __extends(MessageFilePart, _super);

  function MessageFilePart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageFilePart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageFilePart.prototype.getFileMessagePartUrl = function (messagePart) {
    var body = messagePart.body;
    return body.mediaUrl;
  };

  MessageFilePart.prototype.getFilenameFromPart = function (messagePart) {
    var body = messagePart.body;
    return body.originalFileName;
  };

  MessageFilePart.prototype.render = function () {
    var message = this.getMessageFromPart(this.props.part);
    var sourceUrl = this.getFileMessagePartUrl(this.props.part);
    var fileName = this.getFilenameFromPart(this.props.part);
    return React__default.createElement(MessageBubbleFile, {
      fileName: fileName,
      message: message,
      url: sourceUrl
    });
  };

  return MessageFilePart;
}(Component);

export default MessageFilePart;
//# sourceMappingURL=index.js.map
